import { ErrorOutline } from "@mui/icons-material";
import { Link, Stack, Typography } from "@mui/material";
import { UserData } from "Services/api/auth/interfaces";
import { createSearchParams, Link as RouterLink } from "react-router-dom";

export function SignatureMessage({ user: { lead_id, signature } }: { user: UserData }) {
  const params = createSearchParams({
    id: lead_id,
    type: "affiliation",
  }).toString();

  const messages = signature.message.split("\n");
  return (
    <Stack
      sx={{ width: "100%", height: "calc(100vh - 80px - 24px - 56px)", alignItems: "center", justifyContent: "center" }}
      spacing={2}
    >
      <ErrorOutline sx={{ fontSize: "7.5rem" }} color="primary" />
      <Typography sx={{ fontSize: "1.5rem", fontWeight: 400, textAlign: "center" }}>Documentos Pendientes</Typography>
      {messages.map((message) => (
        <Typography key={message} sx={{ fontSize: "1rem", fontWeight: 400, textAlign: "center" }}>
          {message}
        </Typography>
      ))}
      {signature.isDigital && (
        <Link component={RouterLink} to={`/solicitudes/firma/?${params}`}>
          Haz click aqui para firmar los documentos.
        </Link>
      )}
    </Stack>
  );
}
